import { TableContentProperty } from './interface/tableContentHeaders';

export const BASE_TABLE_CONTAINER_ID = 'base-table-container';
export const BASE_TABLE_CONTENT_ID = 'base-table-content';
export const TABLE_HEADER_ID = 'base-table-header';
export const DETAIL_BUTTON_COLUMN_WIDTH = 68; // 詳細ボタン列の幅
export const HEADER_MODIFY_BUTTON_COLUMN_WIDTH = 60; // ヘッダー追加ボタン列の幅
export const STICKY_COLUMN_WIDTH = 88; // 固定列の幅
export const MIN_COLUMN_WIDTH = 88; // 最小列幅
export const MAX_COLUMN_WIDTH = 420; // 最大列幅
export const ORDER_ALERT_ICON_OFFSET = 40; // 注文アラートアイコンのオフセット
export const HEADER_MODIFY_TABLE_CONTENT_PROPERTY: TableContentProperty = {
  key: 'headerModify',
  isVariableWidth: false,
  isNarrowable: false,
  isEditable: false,
  sortOption: {
    isSortable: false,
    isAsc: true,
  },
  headerWidth: 57,
  propertyPath: { paths: [], propertyType: 'string' },
};
